import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import { FilterOperation } from "../../../../components/Grid/dataProvider";
import {FormattedDate} from "react-intl";
// import { FormattedDate } from 'react-intl';

export default (props) => {
    const columns = [
        {
            field: "created",
            displayField: "created",
            label: "Datum",
            type: ColumnType.DATE,
            width: "10%",
        },
        {
            field: "name",
            label: "Nazev",
            type: ColumnType.TEXT,
            width: "40%",
            align: "left",
        },
        {
            field: "ic",
            label: "IČO",
            type: ColumnType.TEXT,
            width: "10%",
            align: "left",
        },
        {
            field: "reason",
            label: "Důvod nahlížení",
            type: ColumnType.TEXT,
            width: "40%",
            align: "left",
            sortable: false,
        },
    ];

    const filters = [
        {
            field: "created",
            operation: FilterOperation.CONTAINS,
            value: "",
        },
        {
            field: "name",
            operation: FilterOperation.CONTAINS,
            value: "",
        },
    ];

    const pageSizeItems = [
        { id: 10, label: "10" },
        { id: 20, label: "20" },
        { id: 50, label: "50" },
        { id: 100, label: "100" },
    ];

    return (
        <CommonGrid
            {...props}
            columns={columns}
            pageSizeItems={pageSizeItems}
            filters={filters}
        />
    );
};

export const WhoLookedFinancialInstitutionGrid = (props) => {
    const columns = [
        {
            field: "created",
            displayField: "created",
            label: "Datum",
            type: ColumnType.DATE,
            width: "10%",
        },
        {
            field: "name",
            label: "Nazev",
            type: ColumnType.TEXT,
            width: "40%",
            align: "left",
        },
        {
            field: "ic",
            label: "IČO",
            type: ColumnType.TEXT,
            width: "10%",
            align: "left",
        },
        {
            field: "reason",
            label: "Důvod nahlížení",
            type: ColumnType.TEXT,
            width: "40%",
            align: "left",
            sortable: false,
        },
    ];

    const filters = [
        {
            field: "created",
            operation: FilterOperation.CONTAINS,
            value: "",
        },
        {
            field: "name",
            operation: FilterOperation.CONTAINS,
            value: "",
        },
    ];

    const pageSizeItems = [
        { id: 10, label: "10" },
        { id: 20, label: "20" },
        { id: 50, label: "50" },
        { id: 100, label: "100" },
    ];

    return (
        <CommonGrid
            {...props}
            columns={columns}
            pageSizeItems={pageSizeItems}
            filters={filters}
        />
    );
};
